// Ionic Angular
import { Component } from "@angular/core";

@Component({
    selector: "tidy-big-icon",
    template: `
  <div class="tidy-big-icon">
    <div class="tidy-item tidy-item-icon">
        <ng-content select="[item-top]"></ng-content>
    </div>
    <div class="tidy-item tidy-item-text">
      <ng-content select="[item-bottom]"></ng-content>
    </div>
  </div>
  `,
    standalone: false
})
export class TidyBigIconComponent {}
